import { push } from "react-router-redux";

const FETCH_TEMPLATES_PAGE_SIZE: number = 2;

interface TemplatesState {
	all: any[];
	pageNumber: number;
	fetchStatus: RequestStatus;
}

const INITIAL_CURRENT_USER_STATE: TemplatesState = {
	all: [],
	pageNumber: 0,
	fetchStatus: "",
};

export default (
	state: TemplatesState = INITIAL_CURRENT_USER_STATE,
	action: any
): TemplatesState => {
	switch (action.type) {
		case "TEMPLATES/FETCH_TEMPLATES/PENDING": {
			return {
				...state,
				fetchStatus: "pending",
			};
		}

		case "TEMPLATES/FETCH_TEMPLATES/SUCCESS": {
			const merged = [...state.all];

			for (const template of action.data.templates) {
				if (!merged.some(t => t.name === template.name)) {
					merged.push(template);
				}
			}

			return {
				...state,
				fetchStatus: "success",
				all: merged,
				pageNumber: action.data.pageNumber + 1,
			};
		}

		case "TEMPLATES/FETCH_TEMPLATES/FAILURE": {
			return {
				...state,
				fetchStatus: "failure",
			};
		}
	}

	return state;
};

// helper to get this reducer's state as a typed value
const templatesState = state => state.templates as TemplatesState;

export const selectAllTemplates = state => templatesState(state).all;
export const selectAllTemplatesFetchStatus = state => templatesState(state).fetchStatus;
